import { useQuery } from '@tanstack/react-query';

import { type CampaignEnrollmentState, listCampaignEnrollments } from '~/services/LuxLoyalty';

import { claimsQueryKeys } from './claimsQueryKeys';

const DEFAULT_PAGE_SIZE = 25;

/** Where the campaign id sits in a campaignEnrollments query key */
const CAMPAIGN_ID_KEY_INDEX = claimsQueryKeys.campaignEnrollmentsBase('').length - 1;

/** A page of a MATCH campaign's enrolments, optionally filtered by state or a single customer. */
export function useListCampaignEnrollments(
  campaignId: string | null,
  state?: CampaignEnrollmentState,
  page = 0,
  pageSize = DEFAULT_PAGE_SIZE,
  customerId?: string,
) {
  return useQuery({
    queryKey: claimsQueryKeys.campaignEnrollments(campaignId ?? '', state, page, pageSize, customerId),
    queryFn: ({ signal }) =>
      listCampaignEnrollments(
        campaignId,
        {
          ...(state ? { state } : {}),
          ...(customerId ? { customerId } : {}),
          limit: pageSize,
          offset: page * pageSize,
        },
        { signal },
      ),
    select: (data) => data.result,
    enabled: !!campaignId,
    // Keep the tab counts on screen while another page or tab of the same campaign loads. Never show another
    // campaign's data: the dialogs stay mounted, and the edit form locks matchCheckUntil from these counts.
    placeholderData: (previousData, previousQuery) =>
      previousQuery?.queryKey[CAMPAIGN_ID_KEY_INDEX] === campaignId ? previousData : undefined,
  });
}
